const RANKING = [
  { rank: 1, title: '鬼灭之刃 柱训练篇', heat: '🔥 98.7万', tag: '新番', change: 'up' },
  { rank: 2, title: '咒术回战 第二季', heat: '🔥 92.3万', tag: '热播', change: 'up' },
  { rank: 3, title: '葬送的芙莉莲', heat: '🔥 85.6万', tag: '高分', change: 'same' },
  { rank: 4, title: '我推的孩子 第二季', heat: '🔥 78.4万', tag: '新番', change: 'up' },
  { rank: 5, title: '进击的巨人 完结篇', heat: '🔥 71.2万', tag: '经典', change: 'down' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">热门排行</h2>
          <p className="text-sm text-foreground-500">本周最受关注的动漫热度排行榜</p>
        </div>

        <div className="max-w-2xl mx-auto">
          {RANKING.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 border-b border-background-200/70 last:border-0 hover:bg-background-50 transition-colors cursor-pointer group"
            >
              <span
                className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-heading flex-shrink-0 ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600'
                }`}
              >
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
              </div>
              <span className="px-2 py-0.5 text-[11px] font-medium rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">
                {item.tag}
              </span>
              <span className="text-xs text-foreground-500 whitespace-nowrap">{item.heat}</span>
              <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                {item.change === 'up' && <i className="ri-arrow-up-line text-green-500 text-sm"></i>}
                {item.change === 'down' && <i className="ri-arrow-down-line text-red-400 text-sm"></i>}
                {item.change === 'same' && <i className="ri-subtract-line text-foreground-400 text-sm"></i>}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}